import {ChangeDetectorRef, Component, inject, OnInit, ViewChild} from "@angular/core";
import {NotificationService} from "~/app/core/notification.service";
import {ApiService} from "~/app/core/api.service";
import * as Log from "~/app/core/log";
import * as jsonData from '~/assets/SVG/categories.json'
import {NONE_TYPE} from "@angular/compiler";
import {OfferInfo} from "~/app/core/model/offer-info";
import {OfferFilter} from "~/app/core/model/offer-filter";
import {OfferThumbnailInfo} from "~/app/core/model/offer-thumbnail-info";
import {momentNow, toDate} from "~/app/core/model/date-str";
import {CoreService} from "~/app/core/core.service";
import {off} from "@angular/fire/database";
import {NavigationService} from "~/app/core/navigation.service";
import {IonContent, Platform} from '@ionic/angular';
import { StorageService } from "~/app/core/storage.service";
import {OfferSearch} from "~/app/core/model/offer-search";
import {ModalType} from "~/app/core/modal.service";
import {
  LocationServicesPopupComponent
} from "~/app/components/location-services-popup/location-services-popup.component";
import {AddressInfo} from "~/app/core/model/address-info";
import {LocationInfo} from "~/app/core/model/location-info";
import {MapService} from "~/app/core/maps.service";
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {SettingsService} from "~/app/core/settings.service";

enum Orientation {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical",
  LOCATION = "location",
  SINGLE = "single",
  FAILED = "failed"
}

enum OfferType {
  ALL = "All",
  FREE = "Free",
  DISCOUNT = "Featured Discount",
  FAVORITE = "My Favorite",
  FLASH = "Flash",
  BOUNCEBACK = "My Bounceback",
  POPULAR = "Popular Local",
  RECOMMENDED = "Recommended",
  NEWEST = "Newest"
}
@Component({
    selector: "home-section",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"]
})

export class HomeComponent implements OnInit {

  data: any = jsonData;
  viewMode: Orientation = Orientation.HORIZONTAL;
  offerType: OfferType = OfferType.FREE;
  category: string = '';
  subCategory: string[] = [];
  free100PercentOnly: boolean = false;
  loadedOfferCategories: Set<string> = new Set();
  filter: OfferFilter = {};
  allOffers: Array<OfferInfo> = [];
  freeOffers: Array<OfferInfo> = [];
  featuredDiscountOffers: Array<OfferInfo> = [];
  flashOffers: Array<OfferInfo> = [];
  myFavoriteOffers: Array<OfferInfo> = [];
  myBouncebackOffers: Array<OfferInfo> = [];
  popularLocalOffers: Array<OfferInfo> = [];
  recommendedOffers: Array<OfferInfo> = [];
  newestOffers: Array<OfferInfo> = [];
  onlineShippingNotIncludedOffers: Array<OfferInfo> = [];
  checked: string = 'all';
  current_location: string = 'Current Location, 5 miles';
  miles: string = '5';
  mile_preset: string[] = ['5', '10', '15', '20', '25', '50'];
  loc: string = 'Current Location';
  selectedOffer: OfferInfo;
  offerLookupInProgress: boolean = false;
  zip: string = null;
  findingLocation: boolean = false;
  locationInfo = new BehaviorSubject<LocationInfo>(null);
  @ViewChild('content') private content: IonContent;
  platform: Platform;
  browser: string;

  constructor(
    private readonly api: ApiService,
    private readonly cd: ChangeDetectorRef,
    private readonly core: CoreService,
    private readonly nav: NavigationService,
    private readonly storageService: StorageService,
    private readonly mapService: MapService,
    private readonly coreService: CoreService,
    private readonly settingsService: SettingsService,
  ) {
  }

  ngOnInit(): void {
    this.updateSearchParams(this.storageService.loadOfferSearch());
    this.reloadOffers();
    this.platform = this.core.platform;
    this.browser = navigator.userAgent.match("Chrome") ? 'chrome' : navigator.userAgent.match("Safari") ? 'safari' : 'other';
  }

  updateSearchParams(offerSearch: OfferSearch) {
    this.miles = offerSearch.radius.toString();
    this.loc = offerSearch.location ? 'Current Location' : offerSearch.zipCode;
    this.current_location = (this.loc != 'Current Location' ? 'Zip Code ' + this.loc : this.loc) + ', ' + this.miles + ' miles';
    console.log('updateSearchParams -> homeComponent miles=' + this.miles + ' loc=' + this.loc + ' current_location=' + this.current_location);
  }

  newCategory(newCategory: string) {
    this.category = newCategory;
    this.subCategory = [];
    console.log(this.category);
  }
  changeChecked(e) {
    this.checked = e.target.value;
    this.reloadOffers();
    console.log(this.checked);
  }
  newSubCategory(newSubCategory: string) {
    if (newSubCategory !== '' && newSubCategory != null) {
      let category_on = -1;
      for (let thing = 0; thing < this.subCategory.length; thing++) {
        if (newSubCategory === this.subCategory[thing]) {
          category_on = thing;
        }
      }
      if (category_on >= 0) {
        this.subCategory.splice(category_on, 1);
      } else {
        this.subCategory.push(newSubCategory);
      }
      console.log(this.subCategory);
    }
    else
      this.subCategory = [];
    this.reloadOffers();
  }

  private loadOffers() {
    console.log("loadOffers");
    this.allOffers = this.getAllOffers();
    this.offerLookupInProgress = true;
    this.freeOffers = this.getFreeOffers();
    this.featuredDiscountOffers = this.getDiscountOffers();
    this.flashOffers = this.getFlashOffers();
    this.myFavoriteOffers = this.getMyFavoriteOffers();
    this.myBouncebackOffers = this.getMyBouncebackOffers();
    this.popularLocalOffers = this.getMostPopularLocalOffers();
    this.recommendedOffers = this.getRecommendedOffers();
    this.newestOffers = this.getNewestOffers();
    this.onlineShippingNotIncludedOffers = this.freeOnlineOffers();
  }

  public reloadOffers() {
    this.loadOffers();
  }

  private getAllOffers() {
    // This should get offers stored locally, then query via api.
    // I think it runs the api asynchronously, often returning before results come back
    let offers: Array<OfferInfo> = this.api.offers_loadOffers(true, this.filter, "all");
    let categories: Set<string> = new Set();

    // If we didn't get any results, query the api directly and wait for it to complete
    // Note: I think this means we're hitting the api twice, as offers_loadOffers presumably is already running it,
    // so this is not optimal. We need a bit of refactoring.
    if (!offers.length || this.searchExpired()) {
      this.api.offers_performSearch().then(result => {
        offers = result;
        if (offers.length)
          this.reloadOffers()
      },
        (error) => {
          // this.showLocationErrorDialog();
          this.viewMode = Orientation.FAILED;
        });
    }
    // console.log(offers);
    this.offerLookupInProgress = false;
    for (let offer of offers) {
      for (let cat of offer.category) {
        if (!categories.has(cat)) {
          categories.add(cat);
        }
      }
    }
    this.loadedOfferCategories = categories;
    return offers;
  }

  searchExpired(): boolean {
    const nextSearchExpire: Date = this.storageService.loadOfferSearchExpiresDate();
    const lastSearch: Date = this.storageService.loadOfferSearchDate();
    if (lastSearch) {
      let expireSearch: Date = this.settingsService.loadSettings().calculateSearchExpires(lastSearch);
      if (nextSearchExpire && nextSearchExpire.getTime() < expireSearch.getTime()) expireSearch = nextSearchExpire;
      const expired = expireSearch.getTime() <= this.settingsService.loadSettings().calculateCurrentTime().getTime();

      if (expired) {
        let expiresDate = new Date(this.settingsService.loadSettings().calculateCurrentTime().getTime() + (12*60*60*1000));  // expires in 12 hours
        this.storageService.storeOfferSearchExpiresDate(expiresDate);
        Log.debug(Log.Tag.OfferService, "Search results expired.");
      }

      return expired;
    } else {
      return false;
    }
  }

  private filterLocalOnline(offer: OfferInfo): boolean {
    if (this.checked === "all")
      return true;
    else if (this.checked === "local" && offer.onlineOnly === false)
      return true;
    else if (this.checked === "online" && offer.onlineOnly === true)
      return true;
    else
      return false;
  }

  private noFilteredOffers(): boolean {
    return !(this.getFreeOffers().length > 0 || this.getNewestOffers().length > 0 || this.getMyBouncebackOffers().length > 0
      || this.getRecommendedOffers().length > 0 || this.getDiscountOffers().length > 0 || this.getMostPopularLocalOffers().length > 0
      || this.getMyFavoriteOffers().length > 0 || this.getFlashOffers().length > 0);
  }

  private getFreeOffers() {
    let result: Array<OfferInfo> = [];
    this.allOffers.forEach((offer) => {
        if (offer.free && offer.shipping !== "additional" && this.offerMatchesSubcategory(offer) && this.filterLocalOnline(offer))
        result.push(offer);
    });
    console.log("free offers: " + result.length);
    return this.shuffle(result);
  }

  private getDiscountOffers() {
    let result: Array<OfferInfo> = [];
    this.allOffers.forEach((offer) => {
      if (!offer.free && this.offerMatchesSubcategory(offer) && this.filterLocalOnline(offer))
        result.push(offer);
    });
    return result;
  }

  private getMyFavoriteOffers() {
    let result: Array<OfferInfo> = [];
    this.allOffers.forEach((offer) => {
      if (offer.favorite && this.offerMatchesSubcategory(offer) && this.filterLocalOnline(offer))
        result.push(offer);
    });
    return result;
  }

  private getMyBouncebackOffers() {
    let result: Array<OfferInfo> = [];
    this.allOffers.forEach((offer) => {
      if (offer.bounceback && this.offerMatchesSubcategory(offer) && this.filterLocalOnline(offer))
        result.push(offer);
    });
    return result;
  }

  private getFlashOffers() {
    // TODO what is a "flash" offer? expires soon?
    let result: Array<OfferInfo> = [];
    return result;
  }

  private getMostPopularLocalOffers() {
    let result: Array<OfferInfo> = [];
    this.allOffers.forEach((offer) => {
      // TODO what determines "local"?
      // TODO popularity based on ? total redemption count? total favorite count? Need to update back-end to return this info.
      if (false && this.offerMatchesSubcategory(offer) && this.filterLocalOnline(offer))
        result.push(offer);
    });
    return result;
  }

  private getRecommendedOffers() {
    let result: Array<OfferInfo> = [];
    this.allOffers.forEach((offer) => {
      // TODO how do we recommend offers? do we need to update the back-end?
      if (false && this.offerMatchesSubcategory(offer) && this.filterLocalOnline(offer))
        result.push(offer);
    });
    return result;
  }

  private getNewestOffers() {
    let result: Array<OfferInfo> = [];
    this.allOffers.forEach((offer) => {
      // any offer starting within the last 7 days
      if (offer.startDate > momentNow().subtract(7, "days").date().toString() && this.offerMatchesSubcategory(offer) && this.filterLocalOnline(offer))
        result.push(offer);
    });
    return result;
  }

  private freeOnlineOffers() {
    let result: Array<OfferInfo> = [];
    this.allOffers.forEach((offer) => {
      if (offer.free && offer.shipping === "additional" && this.offerMatchesSubcategory(offer) && this.filterLocalOnline(offer))
        result.push(offer);
    });
    console.log("100% free offers: " + result.length);
    return result;
  }

  public displayHorizontal() {
    this.viewMode = Orientation.HORIZONTAL;
    this.scrollToTop();
  }
  public displayVertical(offerType: any) {
    this.viewMode = Orientation.VERTICAL;
    this.offerType = OfferType[offerType];
    this.scrollToTop();
  }
  public displayLocation() {
    this.viewMode = Orientation.LOCATION;
    this.miles = '5';
    this.loc = '';
    console.log('displayLocation -> homeComponent miles=' + this.miles + ' loc=' + this.loc + ' current_location=' + this.current_location);
  }

  public scrollToTop() {
    // TODO this isn't reliable
    // if (this.content)
    //   this.content.scrollToTop(500);
  }

  public getOffers() {
    switch(this.offerType) {
      case OfferType.FREE:
        return this.filterOffers(this.freeOffers);
      case OfferType.BOUNCEBACK:
        return this.filterOffers(this.myBouncebackOffers);
      case OfferType.FLASH:
        return this.filterOffers(this.flashOffers);
      case OfferType.DISCOUNT:
        return this.filterOffers(this.featuredDiscountOffers);
      case OfferType.FAVORITE:
        return this.filterOffers(this.myFavoriteOffers);
      case OfferType.NEWEST:
        return this.filterOffers(this.newestOffers);
      case OfferType.POPULAR:
        return this.filterOffers(this.popularLocalOffers);
      case OfferType.RECOMMENDED:
        return this.filterOffers(this.recommendedOffers);
      default:
        return this.filterOffers(this.allOffers);
    }
  }

  private filterOffers(offers: OfferInfo[]): OfferInfo[] {
    let filteredOffers: OfferInfo[] = [];
    offers.forEach(offer => {
      if (this.offerMatchesSubcategory(offer) && this.filterLocalOnline(offer))
        if (!this.free100PercentOnly || (offer.free && offer.shipping != "additional"))
          filteredOffers.push(offer);
    });
    return filteredOffers;
  }

  freeOnlyClicked(freeOnly: boolean) {
    this.free100PercentOnly = freeOnly;
    console.log("free100PercentOnly: " + this.free100PercentOnly);
    this.getOffers();
  }

  private offerMatchesSubcategory(offer: OfferInfo): boolean {
    let selectedSubCategories = new Set(this.subCategory);
    let offerCategories = new Set();
    offer.tags.forEach((tag) => {
      offerCategories.add(tag.tag);
    });
    if (selectedSubCategories.size <= 0) {
      if (this.category) {
        // top-level category selected with no sub-categories, so display all from top-level category
        if (offer.category.includes(this.category))
          return true;
        else
          return false;
      }
      else
        return true;
    }
    else if (offerCategories.size <= 0)
      // offers with no categories do not show up when filtered
      return false;
    else
      // if the intersection of the two sets is not empty, then it's a match
      return new Set([...selectedSubCategories].filter(c => offerCategories.has(c))).size > 0;
  }
  public useCurLoc() {
    this.loc = 'Current Location';
    console.log('useCurLoc -> homeComponent miles=' + this.miles + ' loc=' + this.loc + ' current_location=' + this.current_location);
    this.loc_change_func();
  }
  public loc_change(e) {
    this.loc = e.target.value;
    console.log('loc_change -> homeComponent miles=' + this.miles + ' loc=' + this.loc + ' current_location=' + this.current_location);
  }
  public miles_change(e) {
    this.miles = this.mile_preset[e.target.value];
  }
  public on_loc_change() {
    if (this.loc.trim().length > 0 && this.miles.trim().length > 0) {
      this.updateLocationByZip(this.loc);
      this.loc_change_func();
    } else {
      console.log('No zip');
      this.updateNearestLocations();
    }
  }
  public loc_change_func() {
    let offerSearch: OfferSearch = new OfferSearch();
    this.current_location = this.loc + ', ' + this.miles + ' miles';
    try {
      offerSearch.radius = Number(this.miles);
      if (this.loc !== 'Current Location') {
        offerSearch.location = false;
        offerSearch.zipCode = this.loc;
        this.zip = this.loc;
        this.core.api.offers_setSearch(offerSearch);
      } else {
        offerSearch.location = true;
        this.core.api.offers_setSearch(offerSearch);
        this.zip = null;
      }
      this.storageService.storeOfferSearch(offerSearch);
      this.updateSearchParams(offerSearch);
      this.reloadOffers();

      this.viewMode = Orientation.HORIZONTAL;
    } catch (e) {
      console.log('failure in loc_change_func');
    }
  }

  public displayOffer(offerID: number) {
    this.nav.navPageOffer(offerID);
    // this.viewMode = Orientation.SINGLE;
    // for (let offer of this.allOffers) {
    //   if (offer.id === offerID) {
    //     this.selectedOffer = offer;
    //     break;
    //   }
    // }
  }

  async showLocationErrorDialog() {
    const modalType: ModalType = 'sheet-half';
    const modal = await this.core.modal.create({component: LocationServicesPopupComponent, componentProps: {}}, modalType, 'normal');
    modal.onDidDismiss().then(() => {
      console.log('Location Services Dialog');
    });
  }

  public updateNearestLocations() {
    this.findingLocation = true;
    this.core.api.location_getLocationInfo().then(locationInfo => {
      this.locationInfo.next(locationInfo);
      this.findingLocation = false;
      console.log(locationInfo);
      }, (error) => {
      if (this.zip == null) {
        this.locationInfo.next(null);
        console.log("Error getting location");
        console.log(error);
        this.findingLocation = false;
      }
    });
  }

  public updateLocationByZip(zip: string) {
    this.findingLocation = true;
    this.mapService.init().subscribe((loaded) => {
      if (loaded) {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({address: zip}, (results, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            let locationInfo = new LocationInfo();
            locationInfo.latitude = results[0].geometry.location.lat();
            locationInfo.longitude =results[0].geometry.location.lng();
            this.locationInfo.next(locationInfo);
          }
        });
      }
      this.findingLocation = false;
    });
  }



  seed(s): Function {
    return function() {
      s = Math.sin(s) * 10000;
      return s - Math.floor(s);
    };
  };
  random(seed: number): Function {
    return this.seed(seed);
  }

  shuffle(offers: Array<OfferInfo>): Array<OfferInfo> {
    let shuffledOffers: OfferInfo[] = offers.slice();  // clone the offers list
    let currentIndex = shuffledOffers.length;
    let today: Date = new Date();
    let seed: number = today.getFullYear() * 10000 + today.getMonth() * 100 + today.getDate();

    // While there remain elements to shuffle...
    while (currentIndex != 0) {

      // Pick a remaining element...
      let rnd = this.random(seed + currentIndex)();
      let randomIndex = Math.floor(rnd * currentIndex);
      console.log("randomIndex: " + randomIndex);
      currentIndex--;

      // And swap it with the current element.
      [shuffledOffers[currentIndex], shuffledOffers[randomIndex]] = [
        shuffledOffers[randomIndex], shuffledOffers[currentIndex]];
    }
    return shuffledOffers;
  }
}
